import { isTrue } from './utils';
import { VARIABLES } from './constants';

const baseHref = () => {
  const bases = document.querySelectorAll('base');

  return (bases.length > 0 && bases[0].getAttribute('href')) || '';
};

const appInstanceId = () => `FRIA_DAMAGEDOC_${baseHref().replace(/\//, '_')}`;

const servicesVersion = () => VARIABLES.Version;

const clientVersion = () => VARIABLES.ClientAppVersion;

const environment = () => VARIABLES.AppEnv;

const isProdEnvironment = () => VARIABLES.AppEnv === 'production';

const isVersionVisible = () => true;

const useStaticResources = () => isTrue(VARIABLES.UseStaticResources);

const logInRedirectForWeb = () => {
  const url = `${baseHref()}${VARIABLES.LogInRedirectForWeb}`.replace(/\/\//g, '/');
  const encodedBaseHref = baseHref().replace(/\//g, '%2F');
  return url.replace(/\?ReturnUrl=%2F/g, `?ReturnUrl=${encodedBaseHref}`);
};

const logOutRedirectForWeb = () => {
  const url = `${baseHref()}${VARIABLES.LogOutRedirectForWeb}`.replace(/\/\//g, '/');
  const encodedBaseHref = baseHref().replace(/\//g, '%2F');
  return url.replace(/\?ReturnUrl=%2F/g, `?ReturnUrl=${encodedBaseHref}`);
};

const isDevelopmentOrQaEnv = () => {
  const env = VARIABLES.AppEnv.toLowerCase();

  return env === 'development' || env === 'qa';
};

export const configuration = {
  baseHref,
  appInstanceId,
  servicesVersion,
  clientVersion,
  environment,
  isProdEnvironment,
  isVersionVisible,
  useStaticResources,
  logInRedirectForWeb,
  logOutRedirectForWeb,
  isDevelopmentOrQaEnv,
};
